export const GenitalsMap = {
  female: ['会阴', '肛周', '阴唇', '阴蒂'],
  male: ['会阴', '肛周', '龟头', '阴茎', '阴囊'],
};

export const FaceMap = ['前额', '眼部', '耳朵', '鼻部', '面颊', '口部', '下巴', '头皮'];

export const HandMap = ['手指', '手指缝', '手指甲', '手掌', '手背'];

export const FootMap = ['脚趾', '脚趾缝', '脚趾甲', '脚背', '脚底', '脚后跟'];

export const ModeMap = {
  BODY: 'body',
  FACE: 'face',
  HAND: 'hand',
  FOOT: 'foot',
};
